<template>
  <div>
    <van-row class="main">
      <van-row>
        <van-col span="9">
          <img style="width: 2.3rem; height: 2.3rem" :src="logo" />
        </van-col>
        <van-col span="15">
          <p class="strong">{{ title }}<span>第 1 名</span></p>
          <div class="alignContent">
            <img width="17px" src="../assets/images/renzhen.png" />
            <p class="commonText" style="padding-left: 4px">安全认证</p>
          </div>
          <div>
            <p class="blueText" @click="showIosGuidePopup()">ios安装指引</p>
          </div>
          <div>
            <div id="m" class="installBox" style="display: none">
              <a class="down" :href="downLink" download="" @click="onDownClick">免费安装</a>
            </div>
            <div id="pc" style="display: none">
              <div id="qrcode" class="agency_qrcode"></div>
              <p class="qrText">请使用浏览器或相机扫码下载</p>
            </div>
          </div>
        </van-col>
      </van-row>
      <!-- ---------- rate 5 ----------- -->
      <van-row style="padding: 30px 0px 10px">
        <van-col span="10">
          <div class="fivestar">5.0 ★★★★★</div>
          <p class="commonText" style="color: #d8d8d8">19k 个评分</p>
        </van-col>
        <van-col span="6">
          <div class="centerBox">
            <i style="position: relative; top: -6px; padding-right: 2px">#</i>3
          </div>
        </van-col>
        <van-col span="8" style="text-align: right">
          <div class="fivestar">18+</div>
          <p class="commonText" style="color: #d8d8d8">年龄</p>
        </van-col>
      </van-row>
      <van-divider />
      <!-- ------------- ratings and review --------- -->
      <van-row>
        <van-row>
          <p class="ratingTopic">评分及评论</p>
        </van-row>
        <van-row>
          <van-col span="8" style="text-align: center">
            <p class="mainRate">4.9</p>
            <div class="mainRateBottom">满分 5 分</div>
          </van-col>
          <van-col span="16">
            <div class="star_row">
              <span class="s1"><i></i></span>
              <div class="lineBox">
                <span class="v1"></span>
              </div>
            </div>
            <div class="star_row">
              <span class="s2"><i></i></span>
              <div class="lineBox">
                <span class="v2"></span>
              </div>
            </div>
            <div class="star_row">
              <span class="s3"><i></i></span>
              <div class="lineBox">
                <span class="v3"></span>
              </div>
            </div>
            <div class="star_row">
              <span class="s4"><i></i></span>
              <div class="lineBox">
                <span class="v4"></span>
              </div>
            </div>
            <div class="star_row">
              <span class="s5"><i></i></span>
              <div class="lineBox">
                <span class="v5"></span>
              </div>
            </div>
            <div>
              <p class="mainRateRightText">19k 个评分</p>
            </div>
          </van-col>
        </van-row>
      </van-row>
      <van-divider />
      <!-- ------------- new function -------------- -->
      <van-row>
        <p class="ratingTopic" style="padding: 0px 0px 10px">新功能</p>
        <p style="margin: 0px 0px; font-size: 0.3rem">{{ version }}</p>
      </van-row>
      <van-divider />
      <!-- ----------- information ------------- -->
      <van-row>
        <p class="ratingTopic" style="padding: 0px">信息</p>
      </van-row>
      <van-row class="infoBox">
        <ul>
          <li>
            <span>大小</span>
            <p>未知</p>
          </li>
          <li>
            <span>兼容性</span>
            <p>
              支持安卓和苹果，iOS需要 14
              或更高版本。ios低版本可能会出现不全屏的情况
            </p>
          </li>
          <li>
            <span>语言</span>
            <p>简体中文</p>
          </li>
          <li>
            <span>年龄分级</span>
            <p>限18岁以上</p>
          </li>
          <li>
            <span>Copyright</span>
            <p>© 2022 MobiFun Games Inc</p>
          </li>
          <li>
            <span>价格</span>
            <p>免费</p>
          </li>
          <li>
            <span>隐私政策</span>
            <p>✋</p>
          </li>
        </ul>
      </van-row>
      <!-- -------------- footer --------------- -->
      <van-row class="footer">
        <p>免责声明：</p>
        <p style="text-indent: 15px">
          本网站仅为开发者提供App的下载和安装托管，App内的内容和运营相关事项由App开发者负责，与本网站无关
        </p>
      </van-row>
    </van-row>
    <!-- ----------- ios installation guide ---------------- -->
    <van-popup v-model="showIosGuide" style="width: 90%; height: 95%; padding: 10px">
      <p class="closeText" @click="hideIosGuidePopup()">关闭</p>
      <van-row>
        <img width="100%" src="../assets/images/ios1.jpg" />
        <p class="popupText">第一步 允许下载APP</p>
        <img width="100%" src="../assets/images/ios2.jpg" />
        <p class="popupText">第二步 允许配置 APP</p>
        <img width="100%" src="../assets/images/ios3.jpg" />
        <p class="popupText">第三步 点击右上角安装按钮</p>
        <img width="100%" src="../assets/images/ios4.jpg" />
      </van-row>
    </van-popup>

    <div id="weixin_ios" style="">
      <div class="click_opacity"></div>
      <div class="to_btn">
        <span class="span1">
          <img src="../assets/images/click_btn.png">
        </span>
        <span class="span2">
          <em>1</em> 点击右上角
          <img src="../assets/images/menu.png">
          打开菜单
        </span>
        <span class="span2">
          <em>2</em> 选择
          <img src="../assets/images/safari.png">
          用Safari打开下载
        </span>

      </div>
    </div>
    <div id="weixin_android" style="display: none">
      <div class="click_opacity"></div>
      <div class="to_btn"><span class="span1">
          <img src="../assets/images/click_btn.png">
        </span>
        <span class="span2">
          <em>1</em> 点击右上角
          <img src="../assets/images/menu_android.png">
          打开菜单
        </span>
        <span class="span2 android_open">
          <em>2</em> 选择
          <img src="../assets/images/android_.png">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import QRCode from "qrcodejs2";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "Download",
  data() {
    return {
      showIosGuide: false,
      title: '',
      logo: '',
      version: '',
      weixin: false,
      weibo: false,
      isQQ: false,
      isiOS: false,
      isAndroid: false,
      isSafari: false,
      downLink: '',
      provisionLink: ''
    };
  },
  methods: {
    showIosGuidePopup() {
      this.showIosGuide = true;
    },
    hideIosGuidePopup() {
      this.showIosGuide = false;
    },
    qrcode(url) {
      let qrcode = new QRCode("qrcode", {
        text: url, // 二维码地址
      });
    },
    showPopup() {
      let that = this;
      var browser = {
        versions: function () {
          var u = navigator.userAgent;
          var ua = navigator.userAgent.toLocaleLowerCase();
          var app = navigator.appVersion;
          return {
            trident: u.indexOf('Trident') > -1, // IE内核
            presto: u.indexOf('Presto') > -1, // opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // IOS终端
            android: u.indexOf('Android') > -1, // 安卓终端
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, // 是否为iphone或QQHD浏览器
            iPad: u.indexOf('iPad') > -1, // 是否为iPad
            webApp: u.indexOf('Safari') == -1, // 是否web应用程序，没有头部与底部
            QQbrw: u.indexOf('MQQBrowser') > -1, // QQ浏览器
            weiXin: u.indexOf('MicroMessenger') > -1, // 微信
            QQ: ua.match(/\sQQ/i) == " qq", // QQ App内置浏览器（需要配合使用）
            weiBo: ua.match(/WeiBo/i) == "weibo", // 微博
            safari: /Safari/.test(u) && !/Chrome/.test(u) && u.indexOf('MQQBrowser') < 0 && !/CriOS/.test(u),
            UCbrw: u.indexOf('UCBrowser') > -1, //UC浏览器
            ucSpecial: u.indexOf('rv:1.2.3.4') > -1,
            Symbian: u.indexOf('Symbian') > -1,
            ucSB: u.indexOf('Firofox/1.') > -1
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };
      var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (browser.versions.mobile) {//判断是否是移动设备打开
        if (browser.versions.weiXin) {
          that.weixin = true;
        }
        if (browser.versions.weiBo) {
          that.weibo = true;
        }
        if (browser.versions.QQ) {
          that.isQQ = true;
        }

        if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
          that.isiOS = true;
        }
        if (browser.versions.android) {
          that.isAndroid = true;
        }
        if (browser.versions.safari) {
          that.isSafari = true;
        } else {
          that.isSafari = false;
        }

      }

      // var appType = (this.data.ext == 'iOS') ? 'ios' : 'android';
      if (that.weixin == true) {
        $('.down_load').hide();
        if (that.isiOS == true) {
          $("#weixin_ios").show();
          $("#weixin_android").hide();
        } else {
          $("#weixin_ios").hide();
          $("#weixin_android").show();
        }
      } else {
        $("#weixin_ios").hide();
        $("#weixin_android").hide();
      }
      if (that.isQQ) {
        $('.down_load').hide();
        if (that.isiOS == true) {
          $("#weixin_ios").show();
          $("#weixin_android").hide();
        } else {
          $("#weixin_ios").hide();
          $("#weixin_android").show();
        }
        return false;
      }

      if (that.isiOS && !that.isSafari && (browser.versions.UCbrw)) {
        $('.down_load').hide();
        $("#no_safari").show();
      }
    },
    onDownClick() {
      // this.download(this.downLink);

      /*var ua = window.navigator.userAgent.toLowerCase();
      var Sys = {};
      var s;
      (s = ua.match(/version\/([\d.]+).*safari/)) ? (Sys.safari = s[1]) : 0;
      if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
        setTimeout(() => {
          this.download(this.provisionLink)
        }, 3000);
      }*/
      let that = this;
      var ios_version = navigator.userAgent.match(/OS (\d+)_(\d+)/)
      if (ios_version) {
        var major_version = parseInt(ios_version[1], 10);
        var minor_version = parseInt(ios_version[2], 10);
        if (major_version >= 17) {
          this.$router.push({
            path:'/help'
          })
        } else {
          console.log(1111);
          setTimeout(function() {
              that.download(that.provisionLink)
            },
            4000);
        }
      } else {

        window.location.href = "#";
        
      }

    },
    download(url) {
      var a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', '');
      a.click();
    }
  },
  mounted: function () {
    this.showPopup();
    this.qrcode(window.location.href);
    // -------- check device is pc or mobile ----------
    if (!/windows phone|iphone|android/gi.test(window.navigator.userAgent)) {
      document.getElementById("pc").style.display = "block";
    } else {
      document.getElementById("m").style.display = "block";
    }
    // ----------- check android or apple device ----------
    var ua = window.navigator.userAgent.toLowerCase();
    var Sys = {};
    var s;
    (s = ua.match(/version\/([\d.]+).*safari/)) ? (Sys.safari = s[1]) : 0;
    if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
      // $(".down").click(function (event) {
      //   $(".down").attr("href", window.__env.iosDownloadLink);
      // });
      this.downLink = window.__env.iosDownloadLink;
      this.provisionLink = window.__env.iosMobileProvision;
    }
    if (/(Android)/i.test(ua)) {
      // $(".down").attr("href", window.__env.androidDownloadLink);
      this.downLink = window.__env.androidDownloadLink;
    }

    this.title = window.__env.title;
    this.logo = window.__env.logo;
    this.version = window.__env.version;
  },
};
</script>
<style scoped>
.main {
  padding: 15px;
}

.strong {
  color: #111;
  font-size: 0.4rem;
  display: block;
  margin: 0;
  font-weight: 700;
}

.strong span {
  color: #8e8e93;
  font-size: 0.24rem;
  border-radius: 0.08rem;
  padding: 0.04rem 0.1rem;
  border: 1px solid #8e8e93;
  vertical-align: middle;
  margin-left: 0.1rem;
}

.alignContent {
  align-items: center;
  display: flex;
}

.agency_qrcode {
  width: 100%;
  padding: 10px 0px 0px 60px;
}

.qrText {
  color: #333333;
  font-size: 0.28rem;
  margin: 0.1rem 0px;
}

.commonText {
  margin: 0px;
  font-size: 0.24rem;
}

.fivestar {
  color: #8e8e93;
  font-weight: 700;
  font-size: 0.34rem;
}

.centerBox {
  color: #8e8e93;
  font-size: 0.34rem;
  text-align: center;
  font-weight: 700;
}

.blueText {
  margin: 0px;
  font-size: 0.24rem;
  color: #180deb;
  text-align: right;
}

.installBox .down {
  min-width: 2.1rem;
  background-color: #017afe;
  border-radius: 0.3rem;
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  padding: 0 0.15rem;
  height: 0.62rem;
  line-height: 0.62rem;
  display: inline-block;
}

.ratingTopic {
  font-size: 0.4rem;
  font-weight: 700;
  margin: 0px;
  padding: 10px 0px;
}

.mainRate {
  font-size: 1.2rem;
  color: #4c4c50;
  margin: 0px;
  font-weight: 700;
}

.mainRateBottom {
  font-size: 0.28rem;
  top: -6px;
  position: relative;
  color: #8e8e93;
  font-weight: 700;
}

/* ------- 5 star section ------ */
.star_row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.star_row span {
  width: 1.2rem;
  height: 0.24rem;
  display: inline-block;
  text-align: right;
  position: relative;
}

.star_row span i {
  height: 0.16rem;
  display: inline-block;
  background: url(../assets/images/star.svg) 0 0;
  background-size: 0.18rem 0.34rem;
  position: absolute;
  right: -12%;
  top: 12%;
}

.star_row span.s1 i {
  width: 0.9rem;
}

.star_row .lineBox {
  width: calc(100% - 1.6rem);
  height: 0.05rem;
  border-radius: 0.3rem;
  background-color: #e5e5e5;
  overflow: hidden;
}

.star_row .lineBox span {
  height: 100%;
  border-radius: 0 3px 3px 0;
  background-color: #8e8e93;
  float: left;
}

.star_row .lineBox span.v1 {
  width: 90%;
}

/* ----- 4 star ---- */
.star_row span.s2 i {
  width: 0.72rem;
}

.star_row .lineBox span.v2 {
  width: 10%;
}

/* ----- 3 star ---- */
.star_row span.s3 i {
  width: 0.54rem;
}

.star_row .lineBox span.v3 {
  width: 4%;
}

/* ----- 2 star ---- */
.star_row span.s4 i {
  width: 0.36rem;
}

.star_row .lineBox span.v4 {
  width: 3%;
}

/* ----- 1 star ---- */
.star_row span.s5 i {
  width: 0.18rem;
}

.star_row .lineBox span.v5 {
  width: 1%;
}

.mainRateRightText {
  font-size: 0.28rem;
  position: relative;
  color: #8e8e93;
  margin: 0px;
  text-align: right;
}

/* ------- info box ---------- */
.infoBox ul li {
  line-height: 1.5;
  padding: 0.15rem 0;
  float: none;
  border-bottom: 1px solid #ebedf0;
  display: flex;
  justify-content: space-between;
}

.infoBox ul li span {
  font-size: 0.24rem;
  color: #8e8e93;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.infoBox ul li p {
  width: 80%;
  color: #333;
  font-size: 0.24rem;
  text-align: right;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  margin: 0;
}

.footer {
  background-color: #eee;
  color: #a9a9a9;
  padding: 10px;
}

.footer p {
  margin: 0;
  font-size: 0.2rem;
}

/* ----------- popup ----------- */
.closeText {
  margin: 0;
  padding: 0px 0px 10px;
  font-size: 14px;
  font-weight: 700;
  text-align: right;
}

.popupText {
  margin: 0;
  padding: 10px 0px;
  font-size: 14px;
  font-weight: 700;
}

/* For Desktop View */
@media screen and (min-width: 1024px) {
  .main {
    width: 750px;
    margin-left: -375px;
    left: 50%;
    position: relative;
  }
}

/* For Tablet View */
@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .main {
    padding: 15px;
    width: 750px;
    margin-left: -390px;
    left: 50%;
    position: relative;
  }
}

.click_opacity {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  position: fixed;
  z-index: 10000;
  top: 0px;
}

.to_btn {
  position: fixed;
  top: 10px;
  right: 10px;
  text-align: right;
  z-index: 10001;
  font-family: "微软雅黑";
}

.to_btn span {
  display: block;
}

.to_btn img {
  width: 20%;
  height: auto;
  display: inline-block;
}

.to_btn .span1 {
  font-size: 1.6rem;
  color: #fff;
  margin-top: 5px;
}

.to_btn {
  color: #fff;
}

.to_btn .span2 {
  display: inline-block;
  line-height: 36px;
  width: 80%;
  margin-bottom: 12px;
  text-align: left;
  font-size: 16px;
}

.to_btn .span2 em {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #009dd9;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-right: 3px;
}

.to_btn .span2 img {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px 5px;
}

.to_btn span {
  display: block;
  float: right;
}

.to_btn .android_open img {
  display: inline-block;
  width: 150px;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue